import { useAuthStore } from '@xstudios/xapp-auth/stores/authStore'

export function usePerms(opts) {
  opts = opts || { waitForBootstrap: true }
  const account = useAuthStore()

  const perm = (ruleOrItem) => {
    if (opts.waitForBootstrap && !account.bootstrapped) {
      return false
    }

    if (!ruleOrItem) {
      return true
    }

    if (typeof ruleOrItem === 'string') {
      return account.can(ruleOrItem)
    }

    if (Array.isArray(ruleOrItem)) {
      return account.canAny(ruleOrItem)
    }

    if (typeof ruleOrItem === 'object') {
      if (ruleOrItem.perm) return account.can(ruleOrItem.perm)
      if (ruleOrItem.allPerm) return account.canAll(ruleOrItem.allPerm)
      if (ruleOrItem.anyPerm) return account.canAny(ruleOrItem.anyPerm)
      if (ruleOrItem.permissions) return account.canAny(ruleOrItem.permissions)
      return true
    }

    return true
  }

  return { perm }
}
